








import Vue from 'vue'
import * as types from '@/store/modules/play/types'

export default Vue.extend({
  name: 'SoundOnScore',

  props: {
    id: Number,
    soundId: String,
    trackIndex: Number,
    when: Number, // 再生開始秒数
  },

  computed: {
    /**
     * 音のリソース（このキーに割り当てられている音）
     */
    source (): types.SoundSrc | types.UserRecordedSoundSrc | null {
      // IDからこの音のソースを取得しておく
      const find = this.soundSources.filter((item: types.SoundSrc | types.UserRecordedSoundSrc) => item.soundId === this.soundId)
      return find ? find[0] : null
    },

    /**
     * 効果音のリスト
     */
    soundSources (): types.SoundSrc[] {
      return this.$store.state[types.moduleName].soundSources.effect.concat(this.$store.state[types.moduleName].soundSources.userRecorded)
    },

    /**
     * アイコン画像
     */
    icon (): string {
      return (this.source && this.source.icon) ? this.source.icon : ''
    },

    /**
     * ラベル
     */
    label (): string {
      return (this.source && this.source.label) ? this.source.label : ''
    },

    /**
     * 1秒あたりのトラックの幅
     */
    pxPerSec (): number {
      return this.$store.state[types.moduleName].trackWidthPerSecond
    },

    /**
     * トラック上の配置位置
     */
    left (): string {
      // 1秒で200px
      return `${this.when * this.pxPerSec}px`
    },
  },
})
